
import { types, actions } from './requests'
export const GETFAMILYLIST_TYPES = {
    ...types('GETFAMILYLIST'),
}
export const GETFAMILYLIST_ACTIONS = {
    ...actions('GETFAMILYLIST'),
}